import { TextField } from '@ace-clublabs/shared-component-library';
import { forwardRef } from 'react';
import Chip from '@/features/appointments/components/Chip';

export interface SearchTextFieldProps {
  placeholder?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedResult?: { title: string } | null;
  onClearSelected?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  startAdornment?: React.ReactNode;
}

const SearchTextField = forwardRef<HTMLDivElement, SearchTextFieldProps>(
  (
    {
      placeholder,
      value,
      onChange,
      selectedResult,
      onClearSelected,
      onKeyDown,
      startAdornment,
    },
    ref,
  ) => (
    <TextField
      inputRef={ref}
      placeholder={selectedResult ? '' : placeholder}
      fullWidth
      showClearButton={false}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      sx={(theme) => ({
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none !important',
        },
        '&:hover': {
          '& .MuiInputBase-root': {
            backgroundColor: `${theme.palette.primary[100]} !important`,
          },
        },
      })}
      slotProps={{
        input: {
          startAdornment: selectedResult ? (
            <Chip label={selectedResult.title} onDelete={onClearSelected} />
          ) : (
            startAdornment
          ),
        },
        htmlInput: {
          readOnly: !!selectedResult,
        },
      }}
      data-testid='search-text-field'
    />
  ),
);

SearchTextField.displayName = 'SearchTextField';

export default SearchTextField;
